module.exports = __webpack_public_path__ + "img/241.4313e51e.jpg";